<template>
  <div class="news_wrapper w">
    <div
      v-if="props.componentInfo.config.showTitle"
      class="news_title"
    >
      <div class="news_title_name">
        <img
          class="mgr10"
          src="@/assets/pc/mini-title4.png"
          alt=""
        >
        <span>{{ componentInfo.config.title }}</span>
        <!-- <span>京东教育合作讲师/实战专家</span> -->
      </div>
      <NuxtLink to="/article/list">
        <div
          v-if="props.componentInfo.config.showMore"
          class="news_title_more pointer"
        >
          <span>更多</span>
          <img
            src="https://huawei-newykt-32.obs.cn-north-4.myhuaweicloud.com/1675680587354451969/b664ce8a19524213aa04cf6c928f69dd.png"
            class="arrows"
          />
        </div>
      </NuxtLink>
    </div>
    <!-- 列表 -->
    <div class="banner">
      <div
        class="banner-content"
        @mouseout="mout"
        @mouseover="mover"
      >
        <ul
          class="banner-list"
          style="height: 364px"
        >
          <li
            v-for="(newsList, index) in newsChunk"
            :key="index"
            class="item"
            :class="{ on: index === num }"
          >
            <NuxtLink
              v-for="item in newsList"
              :key="item.id"
              :to="'/tch/view?id=' + item.id"
              class="news_item_wrapper"
            >
              <div class="news_item">
                <div class="news_item_info">
                  <div>
                    <h3>{{ item.title }}</h3>
                  </div>
                  <div class="news_other_info">
                    <div class="tag_box">
                      <template v-if="item.tagList && item.tagList.length > 0">
                        <div
                          class="item_tag"
                          v-for="(node, indey) in item.tagList"
                          :key="node.id"
                          v-show="indey < 2"
                        >{{ node.tagName }}</div>
                      </template>
                    </div>
                    <span>{{ item.readCount }}人浏览</span>
                    <span>{{ item.gmtCreate.split(' ')[0] }}</span>
                  </div>
                </div>
                <div class="news_item_image">
                  <img :src="item.cover" />
                </div>
              </div>
            </NuxtLink>
          </li>
        </ul>
        <ul class="page_dots">
          <span
            v-for="(item, index) in newsChunk"
            :key="index"
            class="dots"
            :class="{ on: index === num }"
            @mouseenter="num = index"
          ></span>
        </ul>
      </div>
    </div>
    <!-- <div class="new_main">
      <NuxtLink
        v-for="item in componentInfo.data"
        :key="item.id"
        :to="'/article/view?id=' + item.id"
        class="news_item_wrapper"
      >
        <div class="news_item">
          <div class="news_info">
            <div class="news_name tx-ov-2">
              {{ item.title }}
            </div>
            <div class="news_desc tx-ov-2">
              {{ item.summary }}
            </div>
            <div class="new_info_desc">
              <span>{{ item.readCount + "人已阅" }}</span>
              <span class="border" />
              <span>{{ item.gmtCreate }}</span>
            </div>
          </div>
          <div
            v-if="item.cover"
            class="item_image_wrapper"
          >
            <img
              class="item_image"
              :src="item.cover"
            >
          </div>
        </div>
      </NuxtLink>
    </div> -->
  </div>
</template>

<script setup>
import { chunk } from 'lodash-es'
const props = defineProps({
  componentInfo: {
    type: Object,
    default: () => {
      return {}
    }
  }
})
const newsChunk = computed(() => {
  return chunk(props.componentInfo.data, 4)
})
const num = ref(0)
const interval = ref(null)
const change = () => {
  interval.value = setInterval(() => {
    if (num.value + 1 >= newsChunk.value.length) {
      num.value = 0
    } else {
      num.value++
    }
  }, 5000)
}
const mout = () => {
  change()
}
const mover = () => {
  clearInterval(interval.value)
}
</script>
<style lang="scss" scoped>
.news_wrapper {
  padding: 25px 0px;
}

.news_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;
  line-height: 22px;
  color: #333;

  .news_title_name {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 24px;
    line-height: 34px;

    img {
      width: 180px;
    }

    span {
      font-size: 14px;
      color: #333;
      margin-left: 40px;
    }
  }

  .news_title_more {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;

    span {
      margin-right: 6px;
    }

    .arrows {
      width: 16px;
      height: 16px;
      padding-right: 0px;
    }
  }
}

.banner {
  position: relative;

  .banner-content {
    margin: 0 auto;
    position: relative;
    // background: #e3e3e3;
  }

  ul {
    position: relative;
  }

  .banner-list {}

  .item {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    opacity: 0;
    height: 100%;
    background-position: center center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    transition: all 1s;

    &.on {
      opacity: 1;
      z-index: 10;
    }

  }

  .page_dots {
    cursor: pointer;
    margin-top: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 15px 0;
    border-radius: 13px;
    height: 26px;

    // background: rgba(0, 0, 0, 0.2);
    &.old {
      left: 0;
      right: 0;
      margin-right: 0;
      bottom: 30px;
    }

    .dots {
      display: inline-block;
      width: 8px;
      height: 6px;
      margin: 0 4px;
      background: #BECADB;
      border-radius: 15px;

      &.on {
        width: 14px;
        background: #888;
      }
    }
  }
}

.news_item_wrapper {
  height: 160px;
  width: 49%;
  padding: 0px 10px;
  box-sizing: border-box;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  background-color: #FFF;
  box-shadow: 0px 0px 10px #ccc;

  .news_item {
    width: 100%;
    height: 100%;
    padding: 15px;
    box-sizing: border-box;
    text-align: center;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    .news_item_image {
      height: 100%;
      width: 125px;
      border-radius: 8px;
      overflow: hidden;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }

      .ps_name {
        position: absolute;
        bottom: 0px;
        width: 100%;
        height: 24px;
        z-index: 9;
        text-align: center;
        line-height: 24px;
        color: #fff;
        background-color: #e85c15;
      }
    }

    .news_item_info {
      height: 100%;
      width: calc(100% - 125px - 4%);
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      h3 {
        margin: 0;
        padding: 0;
        font-weight: bold;
        font-size: 20px;
        line-height: 28px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .info_box {
        width: 100%;
        font-size: 14px;
        line-height: 24px;
        color: #888;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }

      .news_other_info {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        span {
          font-size: 12px;
          color: #999;
        }

        .tag_box {
          width: 40%;

          .item_tag {
            display: inline-block;
            line-height: 12px;
            font-size: 12px;
            padding: 2px 10px;
            box-sizing: border-box;
            background: #eee;
            border-radius: 20px;
            margin-right: 12px;
            color: #999999;
          }
        }
      }

    }
  }
}

.new_main {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
  margin-right: -10px;
}


.news_item_wrapper:nth-last-child(-n + 2) {
  margin-bottom: 0;
}


.item_image_wrapper {
  overflow: hidden;
  height: 80px;
  width: 144px;
  border-radius: 6px;

  .item_image {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}

.news_info {
  flex: 1;
  padding-right: 10px;
}

.news_name {
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #333;
  -webkit-line-clamp: 1;
}

.news_desc {
  padding-top: 5px;
  font-size: 12px;
  line-height: 18px;
  height: 42px;
  color: #999999;
}

.new_info_desc {
  font-size: 12px;
  line-height: 18px;
  white-space: nowrap;
  color: #999999;

  .border {
    background: #becadb;
    display: inline-block;
    height: 10px;
    margin: 0 10px;
    width: 1px;
  }
}
</style>
